"use client";
import {
  Box,
  BoxProps,
  Container,
  Divider,
  Stack,
  Text,
} from "@chakra-ui/react";

export interface SectionHeaderProps extends BoxProps {
  title: string;
  subtitle?: string;

  rightElement?: React.ReactNode;
}
export const SectionHeader = ({
  title,
  subtitle,
  children,
  rightElement,
  ...props
}: SectionHeaderProps) => (
  <Box as="section" pt={{ base: "4", md: "8" }} pb={{ base: "12" }} {...props}>
    <Container>
      <Stack spacing="6">
        <Stack
          spacing="4"
          direction={{ base: "column", sm: "row" }}
          justify="space-between"
        >
          <Box>
            <Text fontSize="lg" fontWeight="bold">
              {title}
            </Text>
            {subtitle && (
              <Text color="muted" fontSize="sm">
                {subtitle}
              </Text>
            )}
          </Box>
          {rightElement}
        </Stack>
        <Divider />
        {children}
      </Stack>
    </Container>
  </Box>
);
